<template>
  <div v-bem>
    <!-- <p
      :class="['badge', {'badge--available': available}, {'badge--out-of-stock': !available}]"
    >{{available ? 'Stock disponible' : 'Stock épuisé'}}</p> -->
    <div v-bem:preview>
      <iframe
				title="exterieur"
				:src="`/onlinestore/three-sixty/exterior/?images=${JSON.stringify(images)}`" frameBorder="0"></iframe>
    </div>
    <p class="notice">{{$t('notices.images')}}</p>
    <!-- <div v-bem:preview="{out: !available}">
      <iframe
				title="exterieur"
				:src="`/three-sixty/exterior/?images=${JSON.stringify(images)}`" frameBorder="0"></iframe>
    </div> -->
    <h3 v-bem:title>{{$t('steps.color.label')}}</h3>
    <ul v-bem:list>
      <!-- <li
        v-for="color in model.couleurs"
        :key="color.id"
        v-bem:list:item="{ active: color.id === selectedColor.id, out: color.id === '34' }"
        @click="selectColor(color)"
      > -->
      <li
        v-for="color in model.couleurs"
        :key="color.id"
        v-bem:list:item="{ active: color.id === selectedColor.id }"
        @click="selectColor(color)"
      >
        <div class="img"><img :src="'https://www.succursalesrenault.ma/onlinestore/couleurs/'+color.image" :alt="color.couleur"></div>
        <p class="name">{{color.couleur}}</p>
        <p class="price" dir="ltr">{{color.code_couleur === 'blanc-glacier' ? $t('steps.color.free') : `+${priceFormat(version.peinture)} DHS`}}</p>
      </li>
    </ul>
    <div class="cta">
      <button class="button button--primary" @click="$emit('next-step')"><span class="button__text">{{$t('cta.selected')}}</span></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Colors',
  data: () => ({
    selectedColor: {},
    // available: false
  }),
  methods: {
    selectColor(color) {
      // if (available) {
        this.selectedColor = color;
        this.$store.commit('selectColor', { ...color, price: color.code_couleur === 'blanc-glacier' ? 0 : this.version.peinture });
      // }
    }
  },
  computed: {
    model() {
      return this.$store.state.models.find(model => model.id_simulateur_modele === this.$store.state.selected.model);
    },
    version() {
      return this.model.voitures.find(version => version.id_simulateur === this.$store.state.selected.version.id);
    },
    images() {
      return [...Array(24)].map((_, index) => `https://www.succursalesrenault.ma/onlinestore/360ext/${this.model.nom_lien.toLowerCase()}/${this.selectedColor.code_couleur}/${index+1}.jpeg`);
    }
  },
  created() {
    const color = this.$store.state.selected.color;
    if (color.id) this.selectedColor = color
    else {
      this.selectedColor = this.model.couleurs[0];
      this.$store.commit('selectColor', { ...this.selectedColor, price: this.version.peinture });
    }
    // else {
    //   const index = this.model.couleurs.findIndex(c => c.available === true);
    //   this.selectedColor = this.model.couleurs[index];
    //   // this.selectedColor = this.model.couleurs[0];
    //   this.$store.commit('selectColor', { ...this.selectedColor, price: this.version.peinture });
    // }
  }
}
</script>

<style scoped lang="scss">
.colors {
  .badge {
    position: relative;
    z-index: 2;
  }
  &__preview {
    position: relative;
    text-align: center;
    // &::after {
    //   content: "";
    //   position: absolute;
    //   top: 0;
    //   left: 0;
    //   width: 100%;
    //   height: 100%;
    //   background-color: rgba($white, 0.5);
    // }
    // &--out {
    //   &::after {
    //     display: block;
    //   }
    // }
    iframe {
      width: 100%;
      max-width: rem(800);
      height: rem(400);
      margin: 0 auto;
      transform: translateY(rem(-50));
    }
  }
  &__title {
    position: relative;
    display: table;
    text-transform: uppercase;
    margin: 0 auto;
    &::before,
    &::after {
      content: "";
      @extend %transform-center-vertical;
      width: rem(100);
      height: rem(2);
      background-color: $main-color;
    }
    &::before {
      left: 0;
      transform: translateX(-120%);
    }
    &::after {
      right: 0;
      transform: translateX(120%);
    }
  }
  &__list {
    text-align: center;
    max-width: rem(1000);
    margin: rem(60) auto 0;
    padding-bottom: rem(60);
    &-item {
      display: inline-block;
      margin: 0 rem(10);
      cursor: pointer;
      max-width: rem(140);
      vertical-align: top;
      .img {
        display: inline-block;
        width: rem(60);
        border: rem(3) solid $white;
        font-size: 0;
        transition: border-color 0.4s;
      }
      p {
        font-family: var(--primary-font);
        font-weight: 300;
        text-transform: uppercase;
        @include font-size(12);
        margin-top: rem(10);
        opacity: 0;
        transition: opacity 0.4s;
        &.price {
          font-family: var(--primary-font-bold);
        }
      }
      &--out {
        position: relative;
        cursor: auto;
        .img {
          &::after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba($white, 0.5);
          }
        }
        p {
         opacity: 1; 
        }
      }
      &--active {
        cursor: auto;
        .img {
          border-color: rgba(var(--primary-color), 1);
        }
        p {
         opacity: 1; 
        }
      }
      &:hover {
        p {
         opacity: 1; 
        }
      }
    }
  }
  .cta {
    text-align: center;
    max-width: rem(1000);
    padding-bottom: rem(60);
    margin: 0 auto rem(60);
    border-bottom: rem(1) solid $dark-gray;
  }
  .notice {
    color: $dark-gray;
    @include font-size;
    max-width: rem(1000);
    margin: 0 auto rem(40);
    text-align: center;
  }
  @include breakpoint('charmander') {
    &__preview {
    text-align: center;
      iframe {
        transform: none;
        max-width: 100%;
        height: rem(260);
      }
    }
    &__list {
      margin: rem(30) auto 0;
      padding-bottom: rem(30);
      &-item {
        margin: 0;
      }
    }
    .notice {
      margin: rem(10) auto;
    }
  }
}
</style>